import React, { useState } from 'react';
import { CognitoUser } from '../types';
import { AWSCredentials } from '../services/cognitoService';
import LoginForm from './LoginForm';
import EditorPanel from './EditorPanel';

export default function AdminPanel() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<CognitoUser | null>(null);
  const [credentials, setCredentials] = useState<AWSCredentials | null>(null);

  const handleLogin = (newUser: CognitoUser, newCredentials: AWSCredentials) => {
    setUser(newUser);
    setCredentials(newCredentials);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    setCredentials(null);
  };

  if (!isAuthenticated || !user || !credentials) {
    return <LoginForm onLogin={handleLogin} loading={false} />;
  }

  return (
    <EditorPanel
      user={user}
      credentials={credentials}
      onLogout={handleLogout}
    />
  );
}
